import { useSyncExternalStore } from 'react';
import {
    ConnectionState,
    getConnectionState,
    subscribeConnectionState,
} from '~/backend/connectionState';

const serverSnapshot = (): ConnectionState => 'connected';

/** The application's connection to the server, re-rendering as it changes. */
export function useConnectionState(): ConnectionState {
    return useSyncExternalStore(
        subscribeConnectionState,
        getConnectionState,
        serverSnapshot
    );
}
